import { createApiSlice } from "@common";
import {
  CURD_CONTACTS,
  CURD_CONTACTS_BY_ID,
  CURD_CONTACTS_BY_OWNER,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addContacts",
    method: "post",
    url: CURD_CONTACTS,
    stateKey: "message",
  },
  {
    name: "getContacts",
    method: "get",
    url: CURD_CONTACTS,
    stateKey: "data",
  },
  {
    name: "getContactsByOwner",
    method: "get",
    url: CURD_CONTACTS_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateContacts",
    method: "put",
    url: CURD_CONTACTS,
    stateKey: "message",
  },
  {
    name: "deleteContacts",
    method: "delete",
    url: CURD_CONTACTS,
    stateKey: "message",
  },
  {
    name: "getContactDetails",
    method: "get",
    url: CURD_CONTACTS_BY_ID,
    stateKey: "details",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "contact",
  apiConfig,
  customReducers,
);
const contactSlice = slice;
// Export the slice's reducer
export default contactSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addContacts,
  getContacts,
  getContactsByOwner,
  updateContacts,
  deleteContacts,
  getContactDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
